<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="languages"
    [attr.aria-label]="'Change language'"
    [title]="'Change language'">
    <mat-icon [svgIcon]="'heroicons_outline:globe-alt'"></mat-icon>
</button>

<!-- Language menu -->
<mat-menu
    [xPosition]="'before'"
    #languages="matMenu">
    <ng-container *ngFor="let lang of availableLangs; trackBy: trackByFn">
        <button
            mat-menu-item
            [class.font-semibold]="lang.id === activeLang"
            (click)="setActiveLang(lang.id)">
            <span class="flex items-center w-full">
                <span class="flex-auto">{{lang.label}}</span>
                <mat-icon
                    *ngIf="lang.id === activeLang"
                    class="ml-3 icon-size-4 text-primary"
                    [svgIcon]="'heroicons_solid:check'"></mat-icon>
            </span>
        </button>
    </ng-container>
</mat-menu>
